import { makeStyles, Theme } from "@material-ui/core"

import { colors } from "@/styles/colors"

type UseStylesProps = {
	isAIActive: boolean
}

const useStyles = makeStyles<Theme, UseStylesProps>(theme => ({
	footerContainer: {
		padding: theme.spacing(1, 1.5),
		gap: theme.spacing(0.75),
		borderTop: (props) => props.isAIActive
			? `1px solid ${colors.purple[100]}`
			: `1px solid ${colors.gray[100]}`,
		backgroundColor: (props) => props.isAIActive
			? colors.purple[50]
			: colors.gray[50],
		borderBottomLeftRadius: theme.spacing(1),
		borderBottomRightRadius: theme.spacing(1)
	},
	iconWrapper: {
		display: "flex",
		alignItems: "center"
	},
	icon: {
		color: (props) => props.isAIActive ? colors.purple[500] : colors.gray[300]
	},
	label: {
		color: (props) => props.isAIActive ? colors.purple[500] : colors.gray[400],
		fontWeight: 600
	}
}))

export default useStyles
